/**
 * File that contains the auth errors in en language.
 * Created on: Thu, 28 Jul 2022 23:29:31 GMT
 * Generated by "fto.js", file created by Jebbarbas.
 */

type FirebaseAuthTranslation = {
  [key: string]: {
    toDev: string;
    toClient: string;
  };
};

export const firebaseAuthTranslation: FirebaseAuthTranslation = {
  'auth/claims-too-large': {
    toDev:
      'Die Ansprüche im Payload, die an setCustomUserClaims() übergeben wurden, überschreiten die maximal zulässige Größe von 1000 Bytes.',
    toClient: 'Standard',
  },
  'auth/email-already-exists': {
    toDev:
      'Die angegebene E-Mail wird bereits von einem bestehenden Benutzer verwendet. Jede E-Mail muss eindeutig sein.',
    toClient:
      'Die angegebene E-Mail wird bereits verwendet, bitte gib eine andere E-Mail an.',
  },
  'auth/email-already-in-use': {
    toDev:
      'Die angegebene E-Mail wird bereits von einem bestehenden Benutzer verwendet. Jede E-Mail muss eindeutig sein.',
    toClient:
      'Die angegebene E-Mail wird bereits verwendet, bitte gib eine andere E-Mail an.',
  },
  'auth/invalid-credential': {
    toDev: '',
    toClient: 'Die eingegebenen Anmeldeinformationen sind ungültig.',
  },
  'auth/invalid-action-code': {
    toDev:
      'Der Link zum zurücksetzen des Passworts ist leider abgelaufen, bitte versuche es erneut!',
    toClient:
      'Der Link zum zurücksetzen des Passworts ist leider abgelaufen, bitte versuche es erneut!',
  },
  'auth/popup-closed-by-user': {
    toDev:
      'Der Popup-Dialog wurde vom Benutzer geschlossen, bevor die Authentifizierung abgeschlossen werden konnte.',
    toClient: 'Standard',
  },
  'auth/id-token-expired': {
    toDev: 'Das bereitgestellte Firebase-ID-Token ist abgelaufen.',
    toClient: 'Ihr ID-Token ist abgelaufen, bitte melde dich erneut an.',
  },
  'auth/id-token-revoked': {
    toDev: 'Das Firebase-ID-Token wurde widerrufen.',
    toClient: 'Ihr ID-Token wurde widerrufen, bitte melde dich erneut an.',
  },
  'auth/insufficient-permission': {
    toDev:
      'Die Anmeldeinformationen, die zur Initialisierung des Admin SDK verwendet wurden, haben unzureichende Berechtigungen, um auf die angeforderte Authentifizierungsressource zuzugreifen.',
    toClient: 'Standard',
  },
  'auth/internal-error': {
    toDev:
      'Der Authentifizierungsserver hat beim Verarbeiten der Anfrage einen unerwarteten Fehler festgestellt.',
    toClient: 'Standard',
  },
  'auth/invalid-argument': {
    toDev:
      'Ein ungültiges Argument wurde an eine Authentifizierungsmethode übergeben.',
    toClient: 'Standard',
  },
  'auth/invalid-claims': {
    toDev:
      'Die benutzerdefinierten Anspruchsattribute, die an setCustomUserClaims() übergeben wurden, sind ungültig.',
    toClient: 'Standard',
  },
  'auth/invalid-email': {
    toDev:
      'Der angegebene Wert für die E-Mail-Benutzereigenschaft ist ungültig. Es muss eine gültige E-Mail-Adresse sein.',
    toClient:
      'Die angegebene E-Mail-Adresse ist ungültig, bitte geben Sie eine gültige E-Mail-Adresse ein.',
  },
  'auth/invalid-password': {
    toDev:
      'Der angegebene Wert für die Passwort-Benutzereigenschaft ist ungültig. Es muss eine Zeichenkette mit mindestens sechs Zeichen sein.',
    toClient:
      'Das angegebene Passwort ist ungültig, bitte geben Sie ein Passwort mit mindestens sechs Zeichen ein.',
  },
  'auth/wrong-password': {
    toDev: 'Die eingegebene E-Mail und das Passwort stimmen nicht überein.',
    toClient: 'Die eingegebene E-Mail und das Passwort stimmen nicht überein.',
  },
  'auth/user-not-found': {
    toDev:
      'Es gibt keinen vorhandenen Benutzerdatensatz, der mit dem angegebenen Bezeichner übereinstimmt.',
    toClient: 'Konto nicht gefunden, bitte überprüfe deine Angaben.',
  },
  // Add translations for other error codes as needed
};